module.exports = __webpack_public_path__ + "img/Voie_Air.f9bcdeee.png";